import type { Mutation } from 'vuex'

import actionTypes from './actionTypes'
import { State, UploadProgressStatus, UploadResultCount } from './state'
import { UploadBulkFiles } from '@/api/bulkFileUpload/model/bulkFileUploadModel'

const mutations: { [actionTypes: string]: Mutation<State> } = {
  [actionTypes.SET_MODAL_BULK_FILE_UPLOAD_ACTIVED]: (state: State, status: boolean) => {
    state.modalBulkFileUploadActived = status
  },

  [actionTypes.SET_MODAL_DISCONTINUE_UPLOAD_ACTIVED]: (state: State, status: boolean) => {
    state.modalDiscontinueUploadActived = status
  },

  [actionTypes.SET_UPLOAD_PROGRESS_STATUS]: (state: State, status: UploadProgressStatus) => {
    state.uploadProgressStatus = status
  },

  [actionTypes.SET_TOTAL_COUNT]: (state: State, totalCount: number) => {
    state.totalCount = totalCount
  },

  [actionTypes.SET_CURRENT_COUNT]: (state: State, currentCount: number) => {
    state.currentCount = currentCount
  },

  [actionTypes.SET_UPLOAD_RESULT_COUNT]: (state: State, uploadResultCount: UploadResultCount) => {
    state.uploadResultCount = uploadResultCount
  },

  [actionTypes.SET_FILE_CHECK_ERROR]: (state: State, errorMessage: string) => {
    state.fileCheckError = errorMessage
  },

  [actionTypes.SET_UPLOAD_FILES]: (state: State, uploadFiles: UploadBulkFiles) => {
    state.uploadFiles = uploadFiles
  },
}

export default mutations
